import ActionModel, { ActionType, ExitType } from 'cio/models/action';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import DeviceAttributeCondition from 'cio/app-models/conditions/device-attribute';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';

export enum PathType {
  ConditionalPath = 'conditional',
  RandomCohortPath = 'random_cohort',
  SegmentMultiSplitPath = 'multi_split_segment',
  AttributeMultiSplitPath = 'multi_split_attribute',
  AllOthersMultiSplitPath = 'multi_split_all_others',
  InactiveMultiSplitPath = 'multi_split_inactive',
  ConditionWaitUntilPath = 'wait_until_condition',
  DelayEventWaitUntilPath = 'wait_until_delay_event',
  MaximumWaitUntilPath = 'wait_until_maximum',
}

interface BasePathData {
  allNodesInPath: ActionModel[];
  label: string;
  actionType: ActionType;
  type: string;
}

export interface ConditionalBranchPathData extends BasePathData {
  actionType: 'conditional_branch_action';
  type: PathType.ConditionalPath;
}

export interface RandomCohortBranchPathData extends BasePathData {
  actionType: 'random_cohort_branch_action';
  type: PathType.RandomCohortPath;
}

export type MultiSplitBranchPathType =
  | PathType.AttributeMultiSplitPath
  | PathType.SegmentMultiSplitPath
  | PathType.AllOthersMultiSplitPath
  | PathType.InactiveMultiSplitPath;

interface BaseMultiSplitBranchPathData extends BasePathData {
  actionType: 'multi_split_branch_action';
  type: MultiSplitBranchPathType;
}

export interface SegmentMultiSplitBranchPathData extends BaseMultiSplitBranchPathData {
  icon: string;
  type: PathType.SegmentMultiSplitPath;
  segmentId: string;
}

export interface AttributeMultiSplitBranchPathData extends BaseMultiSplitBranchPathData {
  condition: AttributeCondition | DeviceAttributeCondition | EventAttributeCondition;
  type: PathType.AttributeMultiSplitPath;
}

export interface AllOthersMultiSplitBranchPathData extends BaseMultiSplitBranchPathData {
  type: PathType.AllOthersMultiSplitPath;
}

export interface InactiveMultiSplitBranchPathData extends BaseMultiSplitBranchPathData {
  type: PathType.InactiveMultiSplitPath;
}

export type MultiSplitBranchPathData =
  | SegmentMultiSplitBranchPathData
  | AttributeMultiSplitBranchPathData
  | AllOthersMultiSplitBranchPathData
  | InactiveMultiSplitBranchPathData;

export type WaitUntilBranchPathType =
  | PathType.ConditionWaitUntilPath
  | PathType.DelayEventWaitUntilPath
  | PathType.MaximumWaitUntilPath;

interface BaseWaitUntilPathData extends BasePathData {
  actionType: 'conditional_wait_action';
  type: WaitUntilBranchPathType;
  icon: string;
}

export interface ConditionWaitUntilPath extends BaseWaitUntilPathData {
  type: PathType.ConditionWaitUntilPath;
  conditions: any;
}

export interface DelayEventWaitUntilPath extends BaseWaitUntilPathData {
  type: PathType.DelayEventWaitUntilPath;
  delayEventAttrOffset: number;
  delayEventAttr: string;
}

export interface MaximumWaitUntilPath extends BaseWaitUntilPathData {
  type: PathType.MaximumWaitUntilPath;
  exitType: ExitType;
  delay: number;
}

export type WaitUntilPathData = ConditionWaitUntilPath | DelayEventWaitUntilPath | MaximumWaitUntilPath;

export type PathData = ConditionalBranchPathData | RandomCohortBranchPathData | MultiSplitBranchPathData;
